import type { ReactNode } from 'react';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';
import { cn } from '@/lib/utils';

type EmptyStateProps = {
  icon: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  className?: string;
};

export function EmptyState({ icon, title, subtitle, className }: EmptyStateProps) {
  return (
    <Empty className={className}>
      <EmptyHeader>
        <EmptyMedia variant="icon" className="size-14 rounded-full">
          {icon}
        </EmptyMedia>
        <EmptyTitle className={cn('text-base font-medium', className)}>{title}</EmptyTitle>
        {subtitle && (
          <EmptyDescription className="text-chat-subtext overflow-hidden text-sm whitespace-nowrap">
            {subtitle}
          </EmptyDescription>
        )}
      </EmptyHeader>
    </Empty>
  );
}
